import {InjectionToken} from '@angular/core';

import {ExitStrategy} from '../interfaces/exit';

export const EXIT_TOKEN = new InjectionToken<ExitStrategy>('Core#EXIT_TOKEN');
